import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  getCurrentOrganization,
  getOrganizationBySlug,
  formatOrganizationDisplayName,
} from '../utils/organizationContext';

/**
 * Resolve organization slug and display name from URL, auth context, or logged-in user.
 */
export function useOrganizationName() {
  const { organizationSlug: authSlug, user } = useAuth();
  const { organizationSlug: urlSlug } = useParams();
  const slug =
    urlSlug || authSlug || user?.organization_slug || getCurrentOrganization();

  const [organizationName, setOrganizationName] = useState(() =>
    formatOrganizationDisplayName(slug)
  );

  useEffect(() => {
    if (!slug) {
      setOrganizationName(formatOrganizationDisplayName(null));
      return;
    }

    let cancelled = false;
    setOrganizationName(formatOrganizationDisplayName(slug));

    getOrganizationBySlug(slug).then((org) => {
      if (!cancelled) {
        setOrganizationName(formatOrganizationDisplayName(slug, org?.name));
      }
    });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { organizationName, organizationSlug: slug };
}

export default useOrganizationName;
